import { useEffect, useState } from "react";
import makeAnimated from "react-select/animated";
import AsyncSelect from "react-select/async";
import useGetHook from "../../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useDebounce } from "../../../customHooks/useDebounceHook";
const animatedComponents = makeAnimated();

const MultipleSelectField = (props: any) => {
  const {
    watch,
    errors,
    register,
    setValue,
    label,
    queryKey,
    url,
    value,
    props: otherProps,
  } = props;
  const limit = 10;
  const [query, setQuery] = useState("");
  const debounceSearch = useDebounce(query);
  const [lastCallback, setLastCallback] = useState<
    ((options: any) => void) | null
  >(null);
  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${debounceSearch}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: debounceSearch,
      ...otherProps,
    },
  });
  const [defaultValue, setDefaultValue] = useState([...value]);
  const onChange = (selected: any) => {
    setValue(register?.name, selected);
    setDefaultValue(selected);
    if (!selected || selected.length === 0) {
      setQuery("");
    }
  };
  const loadOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    setLastCallback(() => callback);
    setQuery(inputValue?.length === 1 ? "" : inputValue);
  };

  useEffect(() => {
    if (lastCallback && serverData) {
      lastCallback(
        serverData.results.map((item: any) => ({
          label: item?.name,
          value: item?.id,
        }))
      );
    }
  }, [serverData]);

  return (
    <div className={tw``}>
      <label htmlFor="">{label}</label>
      <AsyncSelect
        className={tw`mt-1`}
        value={defaultValue}
        loadOptions={loadOptions}
        components={animatedComponents}
        closeMenuOnSelect={false}
        onChange={onChange}
        isMulti
        styles={{
          control(base, props) {
            return {
              ...base,
              backgroundColor: "#EEF5F4",
              border: props.menuIsOpen || props.isFocused ? "none" : "none",
              outline:
                props.menuIsOpen || props.isFocused
                  ? "none !important"
                  : "none  !important",
              cursor: "text",
              minHeight: "32px",
              marginTop: "4px",
            };
          },
        }}
        defaultOptions={
          serverData?.results?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          })) ?? []
        }
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default MultipleSelectField;
